import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7310b168"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = ["min", "max", "value"]
const _hoisted_3 = ["min", "max", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "number",
      min: _ctx.min,
      max: _ctx.currentMax,
      value: _ctx.currentMin,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateMin && _ctx.updateMin(...args))),
      class: "filter-input",
      placeholder: "Von"
    }, null, 40, _hoisted_2),
    _createElementVNode("input", {
      type: "number",
      min: _ctx.currentMin,
      max: _ctx.max,
      value: _ctx.currentMax,
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateMax && _ctx.updateMax(...args))),
      class: "filter-input",
      placeholder: "Bis"
    }, null, 40, _hoisted_3)
  ]))
}